<template>
    <div v-if="!isLatestVersion" class="flex items-center h-screen">
        <p class="text-center font-medium text-tg-text">
            Обновите версию Telegram до последней для использования этого функционала бота
        </p>
    </div>

    <div v-else class="h-tg w-full overflow-scroll scroll-0 py-3 px-6 bg-tg-bg">
        <router-view />
    </div>
</template>
<script setup lang="ts">
import { WebApp } from '@grammyjs/web-app'
import { onMounted } from '@vue/runtime-core'
import { ref } from 'vue'

const isLatestVersion = ref(false)

onMounted(() => {
    isLatestVersion.value = WebApp.isVersionAtLeast('6.2')

    WebApp.enableClosingConfirmation()
    WebApp.expand()
    WebApp.ready()
})
</script>
